export { default } from "./AddContentIcon";
